import React from "react";
import MenuNav from "../../components/portfolio/menu-nav.component";
import PortfolioFooter from "../../components/portfolio/portfolio-footer.component";
import Divider from "../../components/portfolio/divider.component";
import Timeline from "../../components/timeline/timeline.component";

import "./about.styles.css";
import AutoDownload from "../resume/resume.component";
import Navbar from "../../components/navbar/navbar.component";

const About = () => (
  <div>
  <Navbar/>
  <div className="page-wrapper">
    <section className="page-section about-page">
      <h1 className="page-title">About</h1>
      <p className="h3 about-intro">
        Pankaj is a developer who loves to tell a good story — through code, architecture, and systems that actually work.
      </p>
      <Timeline />   
    </section>
    <Divider/>
    <AutoDownload/>
    <PortfolioFooter/>
  </div>
  </div>
);

export default About;
